import { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import NavbarPortal from "../Navbar";
import FooterPortal from "../Footer";
import DetailEditorialSkeleton from "../Skeleton/DetailEditorialSkeleton";

type Editorial = {
  id: number;
  judul: string;
  gambar: string;
  deskripsi: string;
  created_at: string;
  views: string;
};

const API = process.env.REACT_APP_API_BASE_URL;

const DetailEditorial = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [detail, setDetail] = useState<Editorial | null>(null);
  const [lainnya, setLainnya] = useState<Editorial[]>([]);
  const [populer, setPopuler] = useState<Editorial[]>([]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    fetchDetail();
    fetchLainnya();
    fetchPopuler();
  }, [id]);

  useEffect(() => {
    if (!localStorage.getItem("device_id")) {
      const id = crypto.randomUUID();
      localStorage.setItem("device_id", id);
    }
  }, []);

  const fetchDetail = async () => {
    setLoading(true);

    try {
      const deviceId = localStorage.getItem("device_id");

      const res = await axios.get(`${API}/api/editorial/${id}`, {
        headers: {
          "device-id": deviceId,
        },
      });

      setDetail(res.data.data);
    } catch (err) {
      console.error("Gagal fetch detail", err);
    } finally {
      setLoading(false);
    }
  };

  const fetchLainnya = async () => {
    const res = await axios.get(`${API}/api/editorial?per_page=5`);
    setLainnya(res.data.data);
  };

  const fetchPopuler = async () => {
    const res = await axios.get(`${API}/api/editorial-populer?per_page=5`);
    setPopuler(res.data.data);
  };

  const formatDate = (date: string) => {
    return new Date(date).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  if (loading || !detail) {
    return (
      <>
        <NavbarPortal />
        <DetailEditorialSkeleton />
        <FooterPortal />
      </>
    );
  }

  return (
    <>
      <NavbarPortal />

      <div className="max-w-7xl mx-auto px-4 py-10 font-signika">
        <div className="grid lg:grid-cols-3 gap-10">
          {/* LEFT CONTENT */}
          <div className="lg:col-span-2">
            {/* TITLE */}
            <h1 className="text-3xl md:text-4xl font-bold mb-4">{detail.judul}</h1>

            {/* META */}
            <div className="text-sm text-gray-500 flex gap-4 mb-6">
              <span>Admin</span>
              <span>{formatDate(detail.created_at)}</span>
              <span>{detail.views} Views</span>
            </div>

            {/* IMAGE */}
            <img alt="" src={`${API}/${detail.gambar}`} className="w-full rounded-lg mb-6" />

            {/* CONTENT */}
            <div className="prose max-w-none" dangerouslySetInnerHTML={{ __html: detail.deskripsi }} />
          </div>

          {/* SIDEBAR */}
          <div className="space-y-10">
            {/* BERITA LAINNYA */}
            <div>
              <h2 className="font-bold text-lg border-b pb-2 mb-4">Isu Lainnya</h2>

              <div className="space-y-4">
                {lainnya.map((item) => (
                  <Link to={`/berita/${item.id}`} key={item.id} className="flex gap-3 cursor-pointer">
                    <img alt="" src={`${item.gambar}`} className="w-[90px] h-[70px] object-cover rounded" />

                    <div>
                      <p className="text-sm font-medium leading-snug hover:text-primary">{item.judul}</p>

                      <span className="text-xs text-gray-500">{formatDate(item.created_at)}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            {/* BERITA POPULER */}
            <div>
              <h2 className="font-bold text-lg border-b pb-2 mb-4">Isu Populer</h2>

              <div className="space-y-4">
                {populer.map((item) => (
                  <Link to={`/berita/${item.id}`} key={item.id} className="flex gap-3 cursor-pointer">
                    <img alt="" src={`${item.gambar}`} className="w-[90px] h-[70px] object-cover rounded" />

                    <div>
                      <p className="text-sm font-medium leading-snug hover:text-primary">{item.judul}</p>

                      <span className="text-xs text-gray-500">{formatDate(item.created_at)}</span>
                    </div>
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <FooterPortal />
    </>
  );
};

export default DetailEditorial;
